import { Controller } from "@hotwired/stimulus"

// Swaps a broken <img> to a fallback source. Used where an ActiveStorage object
// may be missing from the bucket (the blob row survives but its file is gone, so
// url_for yields a URL that 404s) — the image then shows a placeholder instead of
// the browser's broken-image icon.
//
// Wire it on the <img> itself:
//   <img src="…" data-controller="image-fallback"
//        data-action="error->image-fallback#onError"
//        data-image-fallback-src-value="/fallback.png">
export default class extends Controller {
  static values = { src: String }

  connect() {
    // The image may have already failed before this controller connected (the
    // error event would have fired and been missed). complete + zero natural
    // width after loading means the load failed.
    if (this.element.complete && this.element.naturalWidth === 0) this.onError()
  }

  onError() {
    // Guard against a loop if the fallback itself can't be loaded.
    if (this.element.dataset.imageFallbackApplied) return
    this.element.dataset.imageFallbackApplied = "true"
    this.element.src = this.srcValue
  }
}
